module.exports = __webpack_public_path__ + "static/media/hc2.1ff1e1e7.png";